import Vue from 'vue'
import Router from 'vue-router'

import IndexFrame from '@/components/common/indexFrame.vue'
// import MenuContainer from '@/components/common/MenuContainer.vue'

const Login = () =>
    import ('../components/user/login.vue');
const Index = () =>
    import ('../components/home/index.vue');
const policeIndex = () =>
    import ('../components/home/policeIndex.vue');
const device = () =>
    import ('../components/device/device.vue');
const deviceDetail = () =>
    import ('../components/device/deviceDetail.vue');
const tenant = () =>
    import ('../components/tenant/tenant.vue');
const tenantDetail = () =>
    import ('../components/tenant/tenantDetail.vue');
const account = () =>
    import ('../components/account/index.vue');
const userList = () =>
    import ('../components/user/userList.vue');
const agencyDetail = () =>
    import ('../components/user/agencyDetail.vue');
const policeDetail = () =>
    import ('../components/user/policeDetail.vue');
const newAdd = () =>
    import ('../components/user/newAdd.vue');
const houseList = () =>
    import ('../components/house/houseList.vue');
const houseDetail = () =>
    import ('../components/house/houseDetail.vue');
const houseEdit = () =>
    import ('../components/house/houseEdit.vue');
const houseNew = () =>
    import ('../components/house/houseNew.vue');
const houseMap = () =>
    import ('../components/houseMap/houseMap.vue');
const houseMapCap = () =>
    import ('../components/houseMap/houseMapCap.vue');
const policeHouseList = () =>
    import ('../components/policeHouse/policeHouseList.vue');
const policeHouseDetail = () =>
    import ('../components/policeHouse/policeHouseDetail.vue');
const policeHouseRoomDetail = () =>
    import ('../components/policeHouse/roomDetail.vue');
const rentList = () =>
    import ('../components/renting/rentList.vue');
const rentRoomList = () =>
    import ('../components/renting/rentRoomList.vue');
const rentRoomDetail = () =>
    import ('../components/renting/rentRoomDetail.vue');
const agencyList = () =>
    import ('../components/agencyList/agencyList.vue');

const newAddRent = () =>
    import ('../components/renting/newAddRent.vue');
const smoke = () =>
    import ('../components/smoke/smoke.vue');
const smokeWarring = () =>
    import ('../components/smoke/smokeWarring.vue');
const abnormaWarning = () =>
    import ('../components/home/abnormaWarning.vue');
// const agencyList = ()=> import('../components/agency/agencyList.vue');
// const newAddAgency = ()=> import('../components/agency/newAddAgency.vue');

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/',
            component: IndexFrame,
            redirect: 'index',
            children: [{
                    path: 'index',
                    name: 'index',
                    component: Index
                },
                {
                    path: 'policeIndex',
                    name: 'policeIndex',
                    component: policeIndex
                },

                {
                    path: 'device',
                    name: 'device',
                    component: device
                },
                {
                    path: 'device/deviceDetail',
                    name: 'deviceDetail',
                    component: deviceDetail
                },
                {
                    path: 'tenant',
                    name: 'tenant',
                    component: tenant
                },
                {
                    path: 'houseMap',
                    name: 'houseMap',
                    component: houseMap
                },
                {
                    path: 'houseMapCap',
                    name: 'houseMapCap',
                    component: houseMapCap
                },
                {
                    path: 'tenant/tenantDetail',
                    name: 'tenantDetail',
                    component: tenantDetail
                },
                {
                    path: 'account',
                    name: 'account',
                    component: account
                },
                {
                    path: 'userList',
                    name: 'userList',
                    component: userList
                },
                {
                    path: 'userList/agencyDetail',
                    name: 'agencyDetail',
                    component: agencyDetail
                },
                {
                    path: 'userList/policeDetail',
                    name: 'policeDetail',
                    component: policeDetail
                },
                {
                    path: 'newAdd',
                    name: 'newAdd',
                    component: newAdd
                },
                {
                    path: 'houseList',
                    name: 'houseList',
                    component: houseList
                },
                {
                    path: 'houseList/houseDetail',
                    name: 'houseDetail',
                    component: houseDetail
                },
                {
                    path: 'houseList/houseDetail/houseEdit',
                    name: 'houseEdit',
                    component: houseEdit
                },
                {
                    path: 'houseNew',
                    name: 'houseNew',
                    component: houseNew
                },
                {
                    path: 'policeHouseList',
                    name: 'policeHouseList',
                    component: policeHouseList
                },
                {
                    path: 'policeHouseList/policeHouseDetail',
                    name: 'policeHouseDetail',
                    component: policeHouseDetail
                },
                {
                    path: 'policeHouseList/policeHouseDetail/policeRoomDetail',
                    name: 'policeRoomDetail',
                    component: policeHouseRoomDetail
                },

                {
                    path: 'rentList',
                    name: 'rentList',
                    component: rentList
                },
                {
                    path: 'rentList/rentRoomList',
                    name: 'rentRoomList',
                    component: rentRoomList
                },
                {
                    path: 'rentRoomDetail',
                    name: 'rentRoomDetail',
                    component: rentRoomDetail
                },
                {
                    path: 'newAddRent',
                    name: 'newAddRent',
                    component: newAddRent
                },
                {
                    path: 'agencyList',
                    name: 'agencyList',
                    component: agencyList
                }, {
                    path: 'smoke',
                    name: 'smoke',
                    component: smoke
                }, {
                    path: 'smokeWarring',
                    name: 'smokeWarring',
                    component: smokeWarring
                },
                {
                    path: 'abnormaWarning',
                    name: 'abnormaWarning',
                    component: abnormaWarning
                },
                // {
                //   path: 'newAddAgency',
                //   name: 'newAddAgency',
                //   component: newAddAgency
                // },

            ],
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js